<div class="pre-login">
    <div class="pre-login-col-1 h-100">
        <left-panel-onboarding></left-panel-onboarding>
    </div>
    <div class="pre-login-col-2">
    </div>
    <div class="pre-login-col-3">
        <div class="onboarding-canvas">
            <grid-row class="mt-30">
                <grid-col col="8">
                    <div class="font-400 font-size-20px line-h-25">
                        {{ "PleaseCreditLimitSettings" | translate }}
                    </div>
                </grid-col>
            </grid-row>
            <grid-row class="mt-30">
                <grid-col col="12">
                    <div class="form-group mt-20">
                        <label>{{"CREDITLIMITSETTINGS" | translate}}</label>
                        <drop-down-list dropDownImage="false" dropDownSearch="false"
                            [selectedValue]="this.selectedCardlimit" [dropDownData]="this.CardlimitList"
                            (itemselected)="onCardlimitChange($event)">
                            {{this.selectedCardlimit}}
                        </drop-down-list>
                    </div>
                </grid-col>
            </grid-row>
            <grid-row class="justify-content-between mt-50">
                <grid-col col="auto">
                    <button class="btn-back" (click)="back()">
                        <i class="icon-back"></i>
                    </button>
                </grid-col>
                <grid-col col="9">
                    <!-- <button class="btn-dft" (click)="cardLimitPermanent()">
                        {{ "NEXT" | translate }}
                    </button> -->
                    <button class="btn-dft" (click)="cardRequestPhysicalCard()">
                        {{ "NEXT" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>